import * as React from 'react';

type Props = {
  width?: string;
  height?: string;
  filled?: boolean;
};

/**
 * MUI icon for "Thumb down" chat action
 */
const ThumbDownIcon = ({ width = '16', height = '16', filled = false }: Props) =>
  filled ? (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_256_1921)">
        <path
          d="M4.00002 2L10.6667 2L10.6667 10.6667L6.00002 15.3333L5.16669 14.5C5.08891 14.4222 5.02502 14.3167 4.97502 14.1833C4.92502 14.05 4.90002 13.9222 4.90002 13.8L4.90002 13.5667L5.63335 10.6667L2.00002 10.6667C1.64446 10.6667 1.33335 10.5333 1.06669 10.2667C0.80002 10 0.666687 9.68889 0.666687 9.33333L0.666687 8C0.666687 7.92222 0.67502 7.83889 0.691687 7.75C0.708354 7.66111 0.733353 7.57778 0.766687 7.5L2.76669 2.8C2.86669 2.57778 3.03335 2.38889 3.26669 2.23333C3.50002 2.07778 3.74447 2 4.00002 2ZM12 10.6667L12 2L14.6667 2L14.6667 10.6667L12 10.6667Z"
          fill="#1E2229"
        />
      </g>
      <defs>
        <clipPath id="clip0_256_1921">
          <rect width={width} height={height} fill="white" transform="translate(16 16) rotate(-180)" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path
        d="M10.0001 1.33334H4.00008C3.44675 1.33334 2.97341 1.66668 2.77341 2.14668L0.760081 6.84668C0.700081 7.00001 0.666748 7.16001 0.666748 7.33334V8.66668C0.666748 9.40001 1.26675 10 2.00008 10H6.20675L5.57341 13.0467L5.55341 13.26C5.55341 13.5333 5.66675 13.7867 5.84675 13.9667L6.55341 14.6667L10.9467 10.2733C11.1867 10.0333 11.3334 9.70001 11.3334 9.33334V2.66668C11.3334 1.93334 10.7334 1.33334 10.0001 1.33334ZM10.0001 9.33334L7.10675 12.2267L8.00008 8.66668H2.00008V7.33334L4.00008 2.66668H10.0001V9.33334ZM12.6667 1.33334H15.3334V9.33334H12.6667V1.33334Z"
        fill="#1E2229"
      />
    </svg>
  );

export default ThumbDownIcon;
